
<Layout>
    <template #title v-if="data">
        <OverviewTitle>
            <template v-slot:title(head)>{{ $t('buyer') }}</template>
            <template v-slot:title>{{ data.name }}</template>
            <template v-slot:title(foot)>{{ $t('organization_id') | upper }}: {{ data.ico }}</template>
        </OverviewTitle>
    </template>
    
    <template #nav>

    </template>
    
    <template #main>
        <Loader v-if="isBusy"/>  
    </template>
</Layout>
